import type { ExtractPropTypes } from 'vue'

export const ellipsisProps = {
	breakWord: Boolean,
	width: [Number, String],
	row: { type: [Number, String], default: 1 },
	count: [Number, String],
	data: [Number, String],
	foldable: { type: Boolean, default: true },
	removeHtml: { type: Boolean, default: true },
	unfoldable: Boolean,
	clear: Boolean,
	tip: Boolean,
	flex: Boolean,
	foldText: { type: String, default: '' },
	unfoldText: { type: String, default: '' }
}

export type EllipsisProps = ExtractPropTypes<typeof ellipsisProps>
